import { client } from "api";

export type GetFileRequest = { fileId: string };
export type GetFileResponse = Blob;

export const getFile = ({ fileId }: GetFileRequest) =>
  client
    .get<GetFileResponse>(`/bin/${fileId}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
